/* eslint-disable promise/always-return */
import { AppProps } from 'next/app';
import React, { useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import AppProviders from '€components/AppProviders';
import { persistor, store } from '€slices/store';
import theme from '€theme/index';
import AppRouter from '€components/AppRouter';
// import 'pure-react-carousel/dist/react-carousel.es.css';
import GoogleTagManager from '€components/GoogleTagManager';
import { BeforeInstallPromptEvent } from '€components/PwaInstall/PwaInstallContext';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
        enabled: process.env.NODE_ENV === 'production',
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    });
}

const App = ({ Component, pageProps }: AppProps) => {
    useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');

        if (jssStyles) {
            (jssStyles.parentElement as Element).removeChild(jssStyles);
        }

        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function () {
                navigator.serviceWorker
                    .register('/service-worker.js')
                    .then(
                        registration => {
                            console.log(
                                'Service Worker registration successful with scope: ',
                                registration.scope,
                            );
                        },
                        err => {
                            console.log('Service Worker registration failed: ', err);
                        },
                    )
                    .catch(error => {
                        console.log('serviceWorker error: ', error);
                    });
            });
        }

        const beforeInstallPromptHandler = (e: BeforeInstallPromptEvent) => {
            e.preventDefault();
            global.deferredPrompt = e;
        };

        window.addEventListener('beforeinstallprompt', beforeInstallPromptHandler);

        return () => {
            window.removeEventListener('beforeinstallprompt', beforeInstallPromptHandler);
        };
    }, []);

    return (
        <AppProviders store={store} persistor={persistor} theme={theme}>
            <AppRouter>
                {GTM_ID ? (
                    <GoogleTagManager>
                        <Component {...pageProps} />
                    </GoogleTagManager>
                ) : (
                    <Component {...pageProps} />
                )}
            </AppRouter>
        </AppProviders>
    );
};

export default App;
